import { CheckCircle } from '@mui/icons-material';
import {
    Box,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    useTheme,
} from '@mui/material';
import { MapWithMarker } from 'components/data/MapWithMarker/MapWithMarker';
import DataLabelPairing from 'components/DataLabelPairing/DataLabelPairing';
import { FormSection } from 'components/form';
import { isValid } from 'date-fns';
import { getMonthDayYear } from 'helpers/dates';
import { useUi } from 'hooks/useUi';
import { useFormContext } from 'react-hook-form';
import { VirtualDeviceInput } from 'types';
import styles from './Summary.module.scss';

export function CreateVirtualDeviceModalSummarySection() {
    const { watch } = useFormContext();
    const theme = useTheme();
    const { ui } = useUi();

    const device = watch() as VirtualDeviceInput;

    return (
        <FormSection title="Summary">
            <Card className={styles.card}>
                <CardContent
                    className={`${styles.content}  ${
                        ui.isMobile ? styles.isMobile : ''
                    }`}
                >
                    <Box className={styles.mapContainer}>
                        <Typography variant="h5">
                            Confirm New Virtual Monitor{' '}
                            <CheckCircle color="success" />
                        </Typography>
                        <MapWithMarker address={device.address} />
                    </Box>
                    <Box>
                        <DataLabelPairing data={device.name} label="Name" />
                        <DataLabelPairing
                            data={device.customer_name}
                            label="Customer Name"
                        />
                        <DataLabelPairing
                            data={device.address}
                            label="Address"
                        />
                        <Typography variant="h5">Deliveries</Typography>
                        <Table>
                            <TableHead
                                sx={{
                                    backgroundColor: theme.palette.grey[400],
                                }}
                            >
                                <TableRow>
                                    <TableCell>Delivery</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Gallons</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {device.fillups.map((fillup, index) => (
                                    <TableRow
                                        sx={
                                            index % 2 !== 0
                                                ? {
                                                      backgroundColor:
                                                          theme.palette
                                                              .grey[300],
                                                  }
                                                : undefined
                                        }
                                        key={`${index}${fillup.amount}`}
                                    >
                                        <TableCell component="th" scope="row">
                                            #{index + 1}
                                        </TableCell>
                                        <TableCell>
                                            {isValid(fillup.time)
                                                ? getMonthDayYear(
                                                      fillup.time.getTime()
                                                  )
                                                : 'Invalid date'}
                                        </TableCell>
                                        <TableCell>{fillup.amount}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </CardContent>
            </Card>
        </FormSection>
    );
}
